import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=55874a2c&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55874a2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55874a2c')) {
      api.createRecord('55874a2c', component.options)
    } else {
      api.reload('55874a2c', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=55874a2c&scoped=true&", function () {
      api.rerender('55874a2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24dGlewkPm8C3/JS/comp/Accordion.vue"
export default component.exports